import { Pagination } from "@mui/material";
import { DDD, E2Data } from "../../../lib/ddd/ddd";
import { useEffect, useState } from "react";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const EU_AOrg = new E2Data("EU_AOrg");
EU_AOrg.format = "Full";
//e2Data_EU_WorkflowSteps.orderBy = "Step";
//e2Data_EU_WorkflowSteps.filter = 'UserAccessible=true'

const ClientsGrid = () =>{
    const [displayData, setDisplayData] =  useState([]);
    const [page, setPage] =  useState(1);
    const [count, setCount] = useState(20);

    const fetchNewData = () =>{
        EU_AOrg.skip = page-1 * count;
        EU_AOrg.take = count;
        EU_AOrg.GetData().then(res => {
            console.log(res);
        });
    }

    useEffect(() =>{
        fetchNewData();
    },[])

    return(
        <>
        <table>
            <thead>
                <th>Enter</th>
                <th>Enter</th>
                <th>Enter</th>
                <th>Enter</th>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                </tr>
            </tbody>
        </table>
        <Pagination
            classes={{}}
            count={10000} color="primary"/>
        </>
    )
}

export default ClientsGrid;